import User from "./User" ;
import DateTime from "../core/DateTime" ;
import DBObject from "../utils/DBObject" ;
import CloneContext from "../utils/CloneContext" ;


  export default  class  LeadsListCountRequest extends  DBObject {  private static readonly _FROMDATE: number = 0 ;
  private static readonly _TODATE: number = 1 ;
  private static readonly _USER: number = 2 ;
  public id: number = 0 ;
  public otherMaster: DBObject ;
  private _user: User = null ;
  private _toDate: DateTime = null ;
  private _fromDate: DateTime = null ;
 public constructor ( d3eParams ? : Partial<{fromDate: DateTime, toDate: DateTime, user: User}> ) {
 super();

this.setFromDate(d3eParams?.fromDate ?? null);

this.setToDate(d3eParams?.toDate ?? null);

this.setUser(d3eParams?.user ?? null);
 }
  public get d3eType (  ) : string {
 return 'LeadsListCountRequest' ; 
 }
  public clear (  ) : void {
 this.d3eChanges.clear();
 }
  public get isTransientModel (  ) : boolean {
 return ; 
 }
  public get user (  ) : User {
 return this._user ; 
 }
  public setUser ( val : User ) : void {
 let isValChanged :boolean=this._user !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(LeadsListCountRequest._USER,this._user);

this.updateObservable('user',this._user,val);

this._user=val;

this.fire('user',this);
 }
  public get toDate (  ) : DateTime {
 return this._toDate ; 
 }
  public setToDate ( val : DateTime ) : void {
 let isValChanged :boolean=this._toDate !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(LeadsListCountRequest._TODATE,this._toDate);

this._toDate=val;

this.fire('toDate',this);
 }
  public get fromDate (  ) : DateTime {
 return this._fromDate ; 
 }
  public setFromDate ( val : DateTime ) : void {
 let isValChanged :boolean=this._fromDate !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(LeadsListCountRequest._FROMDATE,this._fromDate);

this._fromDate=val;

this.fire('fromDate',this);
 }
  public get ( field : number ) : any {
 switch ( field ) {
 case LeadsListCountRequest._USER : {
 return this._user ; 
 }

case LeadsListCountRequest._TODATE : {
 return this._toDate ; 
 }

case LeadsListCountRequest._FROMDATE : {
 return this._fromDate ; 
 }
 default: {
 return null ; 
 }
 }
 }
  public updateD3EChanges ( index : number,value : any ) : void {
 if ( this.lockedChanges() ) {
 return ; 
 }

super.updateD3EChanges(index,value);
 }
  public restore (  ) : void {
 /*
TODO: Might be removed
*/

this.d3eChanges.restore(this);
 }
  public deepClone ( clearId = true ) : LeadsListCountRequest {
 let ctx :CloneContext=new CloneContext({ 'clearId':clearId });

return ctx.startClone(this) ; 
 }
  public collectChildValues ( ctx : CloneContext ) : void {
  }
  public deepCloneIntoObj ( dbObj : DBObject,ctx : CloneContext ) : void {
 let obj :LeadsListCountRequest=( dbObj as LeadsListCountRequest );

obj.id=this.id;

obj.setUser(this._user);

obj.setToDate(this._toDate);

obj.setFromDate(this._fromDate);
 }
  public set ( field : number,value : any ) : void {
 switch ( field ) {
 case LeadsListCountRequest._USER : {
 this.setUser(( value as User ));
 break; }

case LeadsListCountRequest._TODATE : {
 this.setToDate(( value as DateTime ));
 break; }

case LeadsListCountRequest._FROMDATE : {
 this.setFromDate(( value as DateTime ));
 break; }
 }
 }
 }